export default __webpack_public_path__ + "static/media/ground.svg";